module.exports = __webpack_public_path__ + "media/images/pdf/box_old-a43677e61afd60e6c10619bae4a69222.png";